import React from 'react'
import { formatDate, formatCnpj } from '@btime/helpers'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const getComplexReplyValue = (reply, path) => {
  return `${reply.value[path]}`
}

export const formatCNPJ = cnpj => {
  return formatCnpj(cnpj.toString())
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  return formatDate(format, date)
}

export const toCurrency = value => {
  const invalid_values = ['N/A', '', NaN]
  if (invalid_values.includes(Number(value))) {
    return
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const findReplyByReference = (replies, reference) => {
  return replies.find(reply => reply.question.reference === reference)
}

export const getRepliesFromBlockQuestion = (replies, blockIndex) => {
  return replies.filter(reply => reply.blockIndex === blockIndex)
}
